<template>
  <vs-popup class="user-edit-popup"
            id="popup"
            :title="isEditMode ? 'VIEW/UPDATE TASK' : 'CREATE TASK'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-row" v-if="isEditMode">
        <div class="vx-col ml-auto flex">

          <vs-dropdown class="cursor-pointer flex" vs-custom-content>

<!--          <feather-icon icon="TagIcon" svgClasses="h-5 w-5" />-->
            <vs-chip style="border-radius: 0" transparent :color="taskStatusColorFactory(form.status)">
              {{ form.status }}
            </vs-chip>

          <vs-dropdown-menu style="z-index: 200001">
            <vs-dropdown-item v-for="(status, index) in statuses" :key="index">
              <span @click.stop="onClickStatusChange(status.key)" :class="`text-${status.color}`"> {{ status.name }} </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateUpdateTask)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Task Name</small>
                <vs-input v-model="form.name" name="name" class="w-full" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row" v-if="!isEditMode">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="" v-slot="{ errors }">
                <small class="label">Assigned Staff</small>
                <v-select :clearable="false" placeholder="" v-model="form.staff_ids" label="name"
                          :closeOnSelect="false"
                          :options="staffs" multiple :reduce="option => option.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row" v-if="isEditMode">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="" v-slot="{ errors }">
                <small class="label">Assigned Staff</small>
                <v-select disabled :clearable="false" placeholder="" v-model="displayed_staff_ids" label="name"
                          :closeOnSelect="false"
                          :options="staffs" multiple :reduce="option => option.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full mb-3 md:mb-0">
              <ValidationProvider vid="due_date" name="due_date" rules="" v-slot="{ errors }">
                <small class="label">Due Date</small>
                <flat-pickr :config="{dateFormat: 'd/m/Y', minDate: isEditMode ? null : 'today'}" class="w-full" v-model="form.due_date"
                              placeholder=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="due_time" name="due_time" rules="" v-slot="{ errors }">
                <small class="label">Due Time</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}" class="w-full" v-model="form.due_time"
                              placeholder=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="required" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea v-model="form.note" height="100px"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit"  class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click.stop="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {mapActions} from "vuex";
  import vSelect from 'vue-select'
  import {RepositoryFactory} from "@/repository/RepositoryFactory";

  const StaffRepository = RepositoryFactory.get('staff');
  const DropDownRepository = RepositoryFactory.get('drop_down')
  const TasksRepository = RepositoryFactory.get('tasks');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  function initialState() {
    return {
      open: false,
      form: {
        due_date: '',
        due_time: ''
      },
      isEditMode: false,
      displayed_staff_ids: [],
      statuses: [
        { name: 'Pending', key: 'pending', color: 'dark' },
        { name: 'In Progress', key: 'in-progress', color: 'warning' },
        { name: 'On Hold', key: 'on-hold', color: 'dark' },
        { name: 'Completed', key: 'completed', color: 'primary' },
        { name: 'Cancelled', key: 'cancelled', color: 'danger' },
      ],
      staffs: [],
    }
  }

export default {
  name: 'CreateTaskPopUp',
  data () {
    return initialState()
  },
  components: {
    'v-select': vSelect,
      flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    ...mapActions(['createTask', 'updateTask', 'changeTaskStatus']),
    async openPopup (task_id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        await this.fetchStaffs()
        if(task_id) {
          this.isEditMode = true
          await this.fetchTaskDetails(task_id)
        }

        this.open = true;
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    onClickCreateUpdateTask() {
      try {
        if(this.isEditMode) {
          this.updateTask({ id: this.form.id, payload: { name: this.form.name, note: this.form.note, due_date: this.form.due_date || '', due_time: this.form.due_time || '' } })
          this.showSuccessMessage('Task updated successfully')
        } else {
          this.createTask(this.form)
          this.showSuccessMessage('Task created successfully')
        }
      } catch (e) {

      }
      this.form = {}
      this.open = false
    },
    onClickStatusChange(key) {
      try {
        this.changeTaskStatus({ id: this.form.id, status: key })
        this.showSuccessMessage('Task status changed successfully')
        this.open = false
      } catch (e) {

      }
    },
    async fetchStaffs() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })

      try {
        const { data } = (await DropDownRepository.getStaffList()).data
        this.staffs = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }

      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    taskStatusColorFactory(status) {
      const find = this.statuses.find((x) => x.name === status)
      return find ? find.color : 'dark'
    },
    onClickReset() {
      this.form = { }
    },
    async fetchTaskDetails(task_id) {
      try {
        const { data } = (await TasksRepository.getTask(task_id)).data
        this.form = data
        this.form.status = data.status.name
        this.displayed_staff_ids = data.assigned_to.map((x) => x.id )
      } catch(error) {
      }
    }
  },
}
</script>

<style scoped>

</style>
